export default {
  toasts: {
    verification_pending: 'A sua verificação está ainda pendente',
  },
};
